import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { getSubscriptionById, updateSubscription } from '../../../services/subscriptionService';
import { Subscription } from '../../../types/subscription';
import SubscriptionForm from './SubscriptionForm';
import formStyles from '../trainees/TraineeForm.module.css';

const EditSubscriptionPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const subscriptionId = Number(id);
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // (1) إضافة حالة للتحكم في زر الإرسال

  useEffect(() => {
    if (!subscriptionId) return;
    getSubscriptionById(subscriptionId)
      .then(setSubscription)
      .catch(() => {
        toast.error('فشل في جلب بيانات الاشتراك.');
        navigate('/admin/subscriptions/list');
      });
  }, [subscriptionId, navigate]);

  const handleSubmit = (data: any) => {
    setIsSubmitting(true); // (2) تفعيل حالة الإرسال
    const promise = updateSubscription(subscriptionId, data);
    toast.promise(promise, {
      loading: 'جاري تحديث الاشتراك...',
      success: () => {
        navigate('/admin/subscriptions/list');
        return 'تم تحديث الاشتراك بنجاح!';
      },
      error: (err) => {
        setIsSubmitting(false); // (3) إيقاف حالة الإرسال عند حدوث خطأ
        return err.response?.data?.message || 'فشل في تحديث البيانات.';
      },
    });
  };

  if (!subscription) return <div>جاري التحميل...</div>;

  return (
    <div className={formStyles.pageContainer}>
      <div className={formStyles.formContainer}>
        <h2 className={formStyles.title}>تعديل الاشتراك رقم: {subscription.id}</h2>
        <SubscriptionForm 
          onSubmit={handleSubmit} 
          initialData={subscription} 
          isEditMode={true} 
          isSubmitting={isSubmitting} // (4) تمرير الحالة إلى النموذج
          lawyers={[]} // <-- !! (5) الحل: تمرير مصفوفة فارغة لإرضاء TypeScript !!
        />
      </div>
    </div>
  );
};

export default EditSubscriptionPage;
